(function ($) {
	// cart functions

	// if cached preview images exist, apply them to cart (and delete images that are no longer relevant)
	// note that this can work either by appending a canvas to the page, or a simple image. image is less overhead but canvas may be useful if the image needs to be scaled down and then up for some stitching simulation through pixelation
	const cachedPreviewData = JSON.parse(localStorage.getItem('cachedPreviewData')) || {};



	if (cachedPreviewData) {
		//css implementation (as the inject image implementation disappears on cart ajax updates)
		const previewStyleTag = document.createElement('style');

		let previewStyleString = '';

		for (const [uuid, itemData] of Object.entries(cachedPreviewData)) {
			previewStyleString += `.cart-item[data-uuid="${uuid}"] .preview-cart {
				background-image: url("${itemData.previewCanvasBase64Data}");
			}`;
		}

		// Set the style string as the innerHTML of the style tag
		previewStyleTag.innerHTML = previewStyleString;

		// Add the style tag to the document head
		document.head.appendChild(previewStyleTag);

		//inject implementation
		/*
		function insertCartPreviews() {
			for (const [uuid, itemData] of Object.entries(cachedPreviewData)) {
				const cartItemEl = qs(`.cart-item[data-uuid="${uuid}"]`);
				if (cartItemEl) {
					//if line item for uuid found, inject preview
					const canvas = document.createElement('canvas');
					canvas.width = 600;
					canvas.height = canvas.width * .7; // 100/70 aspect ratio
					canvas.classList.add('preview-cart');

					const ctx = canvas.getContext('2d');

					const img = new Image();
					// img.width = 600;
					// img.height = canvas.width * .7; // 100/70 aspect ratio
					img.classList.add('preview-cart');
					img.onload = function () {
						ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
						// console.log('prev width', this.width, 'prev height', this.height);
						canvas.dataset.orientation = this.width < this.height ? 'Vertical' : 'Horizontal';
						this.dataset.orientation = this.width < this.height ? 'Vertical' : 'Horizontal';
					};
					img.src = itemData.previewCanvasBase64Data;

					const ipWhitelistCart = [
						'47.6.109.106', //al home
						'47.181.183.243', //al vintage
					];

					$.getJSON('https://api.ipify.org?format=json', function (response) {
						if (ipWhitelistCart.includes(response.ip)) {
							// whitelist code
							// cartItemEl.qs('.cart-item__details').appendChild(canvas); //TODO: uncomment when ready to go live
							cartItemEl.qs('.cart-item__details').appendChild(img); //TODO: uncomment when ready to go live
						} else {
							// blacklist code
							cartItemEl.qs('.cart-item__details').appendChild(img); //TODO: uncomment when ready to go live
						}
					});

				} else {
					// if line item for uuid not found, sanitize/clean it from localstorage. user has either ordered or deleted the item.
					delete cachedPreviewData[uuid];
					localStorage.setItem('cachedPreviewData', JSON.stringify(cachedPreviewData));
				}
			}
		}
		*/

		//run once
		// insertCartPreviews();

		//add listeners to re-insert previews on dom changes. such as when a user has two cart items, removes one, but still has one left.
	}

	// design confirmation
	$('.checkout-button-with-confirm-design').click(function (e) {
		cl('clicked');
		$('.cart-confirm-design-bg').css({ visibility: 'visible', display: '' }).animate({ opacity: '0.4' }, 150);
		$('.cart-confirm-design').css({ visibility: 'visible', display: '' }).animate({ opacity: '1' }, 200);
	});

	$('.cart-confirm-design > .close-modal, .cart-confirm-design-back').on('click', function (e) {
		e.stopPropagation();
		e.stopImmediatePropagation();
		$('.cart-confirm-design, .cart-confirm-design-bg').animate({ opacity: '0' }, 200, function () {
			$(this).css({ visibility: '', display: '' });
		});
	});

	$('.final-check-full-policy-btn').on('click', function () {
		$('.cart-confirm-design-full-terms').css({ visibility: 'visible', display: '' }).animate({ opacity: '1' }, 200);
	});

	$('.cart-confirm-design-full-terms > .close-modal, .cart-confirm-design-close-terms').on('click', function (e) {
		e.stopPropagation();
		e.stopImmediatePropagation();
		$('.cart-confirm-design-full-terms').animate({ opacity: '0' }, 200, function () {
			$(this).css({ visibility: '', display: '' });
		});
	});
})(jQuery);